import React from 'react';
import { Heart, MessageCircle, Flag, ChevronDown, ChevronUp } from 'lucide-react';

interface PostActionsProps {
  postId: string;
  isLiked: boolean;
  likesCount: number;
  commentsCount: number;
  onLike: (e: React.MouseEvent) => void;
  onToggleLikes: () => void;
  onToggleComments: () => void;
  onReport: () => void;
  showLikes: boolean;
}

export function PostActions({
  postId,
  isLiked,
  likesCount,
  commentsCount,
  onLike,
  onToggleLikes,
  onToggleComments,
  onReport,
  showLikes
}: PostActionsProps) {
  return (
    <div className="flex items-center gap-2 mb-3">
      <button
        onClick={onLike}
        className={`group flex items-center gap-1.5 px-3 py-2 rounded-lg font-medium transition-all duration-200 text-sm ${
          isLiked
            ? 'bg-primary-50 dark:bg-primary-900/20 text-primary-600 dark:text-primary-400'
            : 'text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700'
        }`}
      >
        <Heart
          id={`heart-${postId}`}
          className={`w-[18px] h-[18px] transition-all duration-200 ${
            isLiked ? 'fill-current' : ''
          }`}
        />
        <span className="tabular-nums font-semibold">{likesCount}</span>
      </button>
      {likesCount > 0 && (
        <button
          onClick={onToggleLikes}
          className="flex items-center justify-center w-8 h-8 text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
        >
          {showLikes ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
          <span className="sr-only">Afficher les likes</span>
        </button>
      )}
      <button
        onClick={onToggleComments}
        className="group flex items-center gap-1.5 px-3 py-2 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg font-medium transition-all duration-200 text-sm"
      >
        <MessageCircle className="w-[18px] h-[18px]" />
        <span className="tabular-nums font-semibold">{commentsCount}</span>
      </button>
      <button
        onClick={onReport}
        className="flex items-center justify-center w-8 h-8 text-gray-300 dark:text-gray-600 hover:text-gray-500 dark:hover:text-gray-400 rounded-lg transition-colors ml-auto"
      >
        <Flag className="w-4 h-4" />
      </button>
    </div>
  );
}